<template>
  <div
    id="bdmainsection"
    class="cd-section"
  >
    <div class="projects-5">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">
              Hallo! Wir sind Boigner Digital, womit können wir helfen?
            </h2>
            <h4 class="description">
              Als kleines Team von Spezialisten in den Bereichen Softwareentwicklung, Datenmigration und Digitalisierung
              freuen wir uns auf spannende Projekte in den Bereichen:
            </h4>
            <div class="section-space" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-5 ml-auto">
            <card
              type="background"
              raised
              class="card-background-product"
              :style="{ backgroundImage: `url(${project8})` }"
            >
              <h2 class="card-title">
                Beratung
              </h2>
              <p class="card-description">
                Kein sinnvolles und effizientes Projekt ohne gute Beratung. Nur zusammen erreichen wir wirklichen Mehrwert.
              </p>
              <badge type="neutral">
                Consulting
              </badge>
            </card>
          </div>
          <div class="col-md-5 mr-auto">
            <info-section
              type="danger"
              icon="now-ui-icons ui-2_chat-round"
              title="Erstgespräch"
              description="Wir möchten Sie und Ihr Anliegen kennenlernen. Wie es weiter geht, ergibt sich dann meist von selbst."
            />

            <info-section
              type="danger"
              icon="now-ui-icons design-2_ruler-pencil"
              title="Anforderungserhebung"
              description="Sie haben schon ein System, oder eine Idee? Sie brauchen kein fertiges Lastenheft mitzubringen. Wir helfen Ihnen, Anforderungen zu definieren, priorisieren und Kosten-Nutzen sowie Alternativen abzuwägen."
            />

            <info-section
              type="danger"
              icon="now-ui-icons business_chart-pie-36"
              title="KMU.DIGITAL"
              description="Als zertifizierte Berater können wir Ihnen bei der Beantragung einer Förderung für Ihr Digitalisierungsprojekt zur Seite stehen. Unsere Leistungen sind sowohl in der Beratung, als auch in der Umsetzung im Regelfall förderbar."
            />
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-md-5 ml-auto">
            <info-section
              type="warning"
              icon="now-ui-icons users_single-02"
              title="Volle Kontrolle, maximale Freiheit"
              description="Wir bauen die Software, die Ihre Idee und Ihre Prozesse vorantreibt. Was mit Ihren Daten geschieht, wo das System Sie voll automatisiert unterstützt und wo Sie lieber manuell entscheiden, liegt bei Ihnen."
            />

            <info-section
              type="warning"
              icon="now-ui-icons objects_globe"
              title="Technologisch unabhängig"
              description="Durch langjährige Erfahrung sind wir technologisch sehr flexibel. Ob .NET oder klassische Webtechnologien, ob in der Cloud oder auf Ihrem eigenen Server."
            />

            <info-section
              type="warning"
              icon="now-ui-icons arrows-1_refresh-69"
              title="Schnittstellen"
              description="Sie möchten Daten intern oder extern austauschen, oder Systeme miteinander kommunizieren lassen? Wir lassen Ihre Systeme miteinander sprechen."
            />
          </div>
          <div class="col-md-5 mr-auto">
            <card
              type="background"
              raised
              class="card-background-product"
              :style="{ backgroundImage: `url(${project9})` }"
            >
              <h3 class="card-title">
                Individualentwicklung
              </h3>
              <p class="card-description ">
                Volle Freiheit und Flexibilität durch individuell für Sie entwickelte Software.
                Ob neuer Webshop, Schnittstellen in Ihr aktuelles System oder ein gänzlich neues System - Sie können auf uns zählen.
              </p>
              <badge type="neutral">
                Software Development
              </badge>
            </card>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-md-5 ml-auto">
            <card
              type="background"
              raised
              class="card-background-product"
              :style="{ backgroundImage: `url(${project8})` }"
            >
              <h2 class="card-title">
                Baukasten
              </h2>
              <p class="card-description">
                Sie möchten ein Altsystem ablösen, oder brauchen für einen neuen Business Case ein eigenes System?
                Wir bieten mit 123db eine Datenbank im Baukastenprinzip an. Von schlichtem CRM bis zur Personaleinsatzplanung ist alles möglich.
              </p>
              <badge type="neutral">
                Unternehmenssoftware
              </badge>
            </card>
          </div>
          <div class="col-md-5 mr-auto">
            <info-section
              type="success"
              icon="now-ui-icons objects_spaceship"
              title="Schnell in der Umsetzung"
              description="Basissystem installieren, Benutzer anlegen, und los gehts!"
            />

            <info-section
              type="success"
              icon="now-ui-icons shopping_box"
              title="Modular"
              description="Sie möchten nicht nur Kontakt- und Firmendaten pflegen, sondern auch Ihre Eingangsrechnungen verwalten, Ihren Lagerstand im Auge behalten oder Angebote schreiben? Wir haben Module für unterschiedliche Anforderungen bereit zur Installation."
            />

            <info-section
              type="success"
              icon="now-ui-icons design-2_ruler-pencil"
              title="Einfach"
              description="Unternehmenssoftware ist oft überladen mit Funktionen, die man nie benutzt. Keep it simple, Sie bestimmen was Sie brauchen und was nicht."
            />

            <info-section
              type="success"
              icon="now-ui-icons design-2_ruler-pencil"
              title="Individualentwicklung on top"
              description="Einfache Installation und Module, das verspricht Standardsoftware auch. Als Individualentwickler können wir Ihnen die Funktion für Ihr System bieten, die genau Ihrem Prozess entspricht."
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card, InfoSection,  Badge, Button, Tabs, TabPane } from '@/components';

  export default {
    components: {
      Card,
      Tabs,
      TabPane,
      Badge,
      InfoSection,
      [Button.name]: Button
    },
    data() {
      return {
        project8: require('@/assets/img/project8.jpg'),
        project9: require('@/assets/img/project9.jpg')
      }
    }
  }
</script>
<style>
</style>
